"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonCapability = void 0;
var PersonCapability;
(function (PersonCapability) {
    PersonCapability["PERSON_EDIT"] = "person:edit";
})(PersonCapability || (exports.PersonCapability = PersonCapability = {}));
